// XXX: UPDATE RELEASE DATE WHEN PROVIDED. THIS IS A PLACEHOLDER DATE: September 20, 2025, 12:00:00 AM CST
// Release dates will be product-specific, so this constant will be expanded to map each product to its respective date.
export const RELEASE_DATE = '2025-09-20T05:00:00.000Z';

export const checkReleaseAvailability = (deployGeo, releaseDate) => {
  if (deployGeo === 'eu') {
    // Question: Should we use LD to fill in this ISO date string?
    const parsedReleaseDate = Date.parse(releaseDate);

    // If the parsed date string is an actual number in seconds.
    if (!isNaN(parsedReleaseDate)) {
      return Date.now() > parsedReleaseDate;
    }

    // If we can't parse this date then let's play it safe and disable the product.
    return false;
  }
  return true;
};
